import {
  ThemedFunctor, getSpacing, SpacingName,
} from '@doveit/bricks';
import { css } from 'styled-components';

export const base: ThemedFunctor = ({ theme }) => css`
  ${getSpacing.padding(theme, [SpacingName.MEDIUM, SpacingName.SMALL])}
  background-color: ${theme.palettes.neutrals.lightest};
  border: 1px solid ${theme.palettes.neutrals.light};
  border-radius: 3px;
  flex: 1;
  min-height: 17.25rem;
  max-width: 28.25rem;
`;

export const message: ThemedFunctor = () => css`
  text-align: center;
`;
